<template>
    <div class="vue-active-marker">
        <div class="inner">
            <perfect-scrollbar>
                <button @click="handleClose" class="close-toggle mb-4">{{ backText }}</button>

                <img v-if="hasImage" :src="marker.image" :alt="marker.title" class="mb-3 marker-image">

                <h3 class="virtual-h2">{{ marker.title }}</h3>

                <ul class="details">
                    <li>{{ marker.streetNumber }}</li>
                    <li>{{ marker.postalCodePlace }} </li>
                    <li class="divider"></li>
                    <li><a :href="`tel:${parsedPhoneNumber}`">{{ marker.tel }}</a></li>
                    <li><a :href="`mailto:${secureEmail}`" target="_blank">{{ emailText }} {{ marker.title }}</a></li>
                </ul>

                <a v-if="hasGoogleInside" href="#" @click.prevent="handle360" class="google-360-toggle d-block mt-4">{{ lookInsideText }}</a>

                <a :href="`https://www.google.com/maps/dir//${ marker.geoLocation.lat },${ marker.geoLocation.lng }`" target="_blank" class="btn-secondary mt-4">{{ planRouteText }}</a>

                <div class="office-hours">
                    <h4>{{ openingHoursText }}</h4>

                    <table class="w-100">
                        <tr v-for="day in marker.openingHours.days" class="align-top" :class="{'current': day.active}">
                            <td>{{ day.name }}</td>

                            <td v-if="hasSlots(day.slots)">
                                <span class="d-block" v-for="slot in day.slots">
                                    {{ slot.open }} - {{ slot.closed }}
                                </span>
                            </td>

                            <td v-else>{{ closedText }}</td>
                        </tr>
                    </table>
                </div>
            </perfect-scrollbar>
        </div>
    </div>
</template>

<script>
import parsePhoneNumber from './../../../../../themes/custom/ef2_custom/node_modules/libphonenumber-js';

export default {
    name: "ActiveMarker",

    props: ['marker', 'eventBus'],

    data() {
        return {
            closedText: window.Drupal.t('Closed'),
            openingHoursText: window.Drupal.t('Opening hours'),
            lookInsideText: window.Drupal.t('Take a look inside'),
            planRouteText: window.Drupal.t('Plan route'),
            backText: window.Drupal.t('Back'),
            emailText: window.Drupal.t('E-mail'),
        }
    },

    computed: {
        parsedPhoneNumber() {
            if (_.isEmpty(this.marker.tel)) {
                return;
            }

            return parsePhoneNumber(this.marker.tel, 'NL').number;
        },

        hasGoogleInside() {
            return ! _.isEmpty(this.marker.google360Url);
        },

        secureEmail() {
            return this.marker.email.replaceAll('@','%40');
        },

        hasImage() {
            return ! _.isEmpty(this.marker.image);
        },
    },

    methods: {
        handleClose() {
            this.eventBus.$emit('remove-active-marker');
        },

        handle360() {
            this.eventBus.$emit('open-360-wrapper', this.marker.google360Url);
        },

        hasSlots(slots) {
            return !_.isEmpty(slots);
        }
    }
}
</script>